import designSystem from '@styles/designSystem';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';

interface TitleProps {
    text: string;
}

export const H1Title: React.FC<TitleProps> = ({ 
		text, 
	}) => {

	return (
        <h1>
            {text}
        </h1>
	);
};

export const H2Title: React.FC<TitleProps> = ({ 
		text, 
	}) => {

	return (
        <h2>
            {text}
        </h2>
	);
};


export const Subtitle: React.FC<TitleProps> = ({ 
		text, 
	}) => {

	return (
        <p style={{
            fontSize: isMobile ? designSystem.fontSizeSm : designSystem.fontSizeMd,
            color: designSystem.colorTextSecondary,
            marginTop: 0,
            fontWeight: designSystem.fontWeightWarning,
            lineHeight: 1.4
        }}>
            {text}
        </p>
	);
};

